/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'
import {hasPermission, Permissions} from '../../../../app/modules/auth/permissions'

export function AsideMenuMain() {
  const {currentUser, auth} = useAuth()
  const menus: Array<string> = currentUser?.menus || []
  const isAdmin = hasPermission(auth?.role, Permissions.ManageSystem)

  const intl = useIntl()
  const uniqueTags: string[] = []
  Object.keys(menus).forEach((fullstr: any) => {
    let one = menus[fullstr].split('_')[0].split('|')[1]
    const zero = menus[fullstr].split('_')[0].split('|')[0]
    if (uniqueTags.indexOf(one) === -1 && zero !== 'main') {
      if (one.split('-').length === 1) one = one + '-arrows/arr001.svg'
      uniqueTags.push(one)
    }
  })
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/abstract/abs042.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/cbbee'
        icon='/media/icons/duotune/general/gen025.svg'
        title={intl.formatMessage({id: 'MENU.CBEE', defaultMessage: 'C&Bee'})}
        fontIcon='bi-diagram-3'
      />
      {isAdmin && (
        <AsideMenuItem
          to='/applicationuser/list'
          icon='/media/icons/duotune/communication/com014.svg'
          title='Kullanıcı Yönetimi'
          fontIcon='bi-people'
        />
      )}
      {isAdmin &&
        Object.keys(menus).map((fullstr: any) => {
          return (
            menus[fullstr].split('_')[0].split('|')[0] === 'main' && (
              <AsideMenuItem
                key={fullstr}
                to={'/' + menus[fullstr].split('_')[1].split('|')[0]}
                icon={
                  menus[fullstr].split('_')[1].split('|')[1].split('-').length === 1
                    ? '/media/icons/duotune/arrows/arr001.svg'
                    : '/media/icons/duotune/' +
                      menus[fullstr].split('_')[1].split('|')[1].split('-')[1]
                }
                title={intl.formatMessage({
                  id: 'MENU.' + menus[fullstr].split('_')[1].split('|')[1],
                })}
                fontIcon='bi-app-indicator'
              />
            )
          )
        })}
      {isAdmin &&
        uniqueTags.map((tag: any) => (
          <AsideMenuItemWithSub
            key={tag}
            to={'/' + tag.split('-')[0]}
            title={intl.formatMessage({id: 'MENU.' + tag.split('-')[0]})}
            fontIcon='bi-sticky'
            icon={'/media/icons/duotune/' + tag.split('-')[1]}
          >
            {Object.keys(menus).map((fullstr: any) => {
              return (
                menus[fullstr].split('_')[0].split('|')[1].split('-')[0] === tag.split('-')[0] && (
                  <AsideMenuItem
                    key={fullstr}
                    to={'/' + menus[fullstr].split('_')[1].split('|')[0]}
                    icon={
                      menus[fullstr].split('_')[1].split('|')[1].split('-').length === 1
                        ? '/media/icons/duotune/arrows/arr001.svg'
                        : '/media/icons/duotune/' +
                          menus[fullstr].split('_')[1].split('|')[1].split('-')[1]
                    }
                    title={intl.formatMessage({
                      id: 'MENU.' + menus[fullstr].split('_')[1].split('|')[1].split('-')[0],
                    })}
                    fontIcon='bi-app-indicator'
                  />
                )
              )
            })}
          </AsideMenuItemWithSub>
        ))}
    </>
  )
}
